import { useAppDispatch, useAppSelector } from 'src/app/store/hooks';
import { TagsFilter } from 'src/common/tags/TagsFilter';

import { fleetSlice } from '../../fleet.slice';

export function VehicleTagColumnFilter({
  open,
  onClose,
}: {
  open: boolean;
  onClose: () => void;
}) {
  const dispatch = useAppDispatch();
  const selected = useAppSelector((state) => state.fleet.vehicleTags);

  return (
    <TagsFilter
      open={open}
      selected={selected}
      triggerElement={<div />}
      onApply={(tags) => {
        dispatch(fleetSlice.actions.onVehicleTagApply(tags));
      }}
      onClose={onClose}
    />
  );
}
